<button class="c-button c-button--tp u-no-p" type="button" id="openPopUpInfoButton" (click)="vm.handleRefButtonClick()" data-ref>
	<i class="o-icon o-icon--info" aria-hidden="true" [ngStyle]="vm.color && {'color':vm.color}"></i>
</button>
<div class="c-popover" *ngIf="vm.isOpen">
	<div class="c-popover__container">
		<button type="button" class="c-popover__close" id="closePopUpInfoButton" (click)="vm.handleCloseButtonClick()">
			<i class="o-icon o-icon--x" aria-hidden="true"></i>
			<span class="u-sr-only">{{ 'Common.Close' | translate }}</span>
		</button>
		<p class="c-text" style="margin-bottom: 8px">
			<b>{{'Hr_Dashboard.Calculation_Info.Second_Block_Title' | translate}}:</b>
			{{'Hr_Dashboard.Calculation_Info.Second_Block_Content' | translate}}
		</p>
		<p class="c-text" style="margin-bottom: 8px">
			<b>{{'Hr_Dashboard.Calculation_Info.First_Block_Title' | translate}}:</b>
			{{'Hr_Dashboard.Calculation_Info.First_Block_Content' | translate}}
		</p>
		<p class="c-text" style="margin-bottom: 16px">
			<b>{{'Hr_Dashboard.Calculation_Info.Third_Block_Title' | translate}}:</b>
			{{'Hr_Dashboard.Calculation_Info.Third_Block_Content' | translate}}
		</p>
		<p *ngIf="!vm.isMobile"><b>{{'Hr_Dashboard.Table_Hr_Invitations.Links' | translate}}:</b></p>
		<p *ngIf="!vm.isMobile">
			<a class="c-pager__link--active" (click)="vm.redirect($event, 'https://www2.deloitte.com/content/dam/Deloitte/uk/Documents/public-sector/deloitte-uk-mental-health-employers-monitor-deloitte-oct-2017.pdf')" href="javascript:void(0)">
				{{'Hr_Dashboard.Calculation_Info.First_Link_title' | translate}}
			</a>
		</p>
		<p *ngIf="!vm.isMobile">
			<a class="c-pager__link--active" (click)="vm.redirect($event, 'https://faq.sparckco.com/knowledge/step-by-step-calculations-for-absenteeism-costs-and-projected-savings')" href="javascript:void(0)">
				{{'Hr_Dashboard.Calculation_Info.Second_Link_title' | translate}}
			</a>
		</p>
		<p *ngIf="!vm.isMobile">
			<a class="c-pager__link--active" (click)="vm.redirect($event, 'https://hbr.org/2004/10/presenteeism-at-work-but-out-of-it')" href="javascript:void(0)">
				{{'Hr_Dashboard.Calculation_Info.Third_Link_title' | translate}}
			</a>
		</p>
	</div>
</div>
